<div
	[class]="
		cn(
			'grid grid-cols-1 gap-1',
			grid() === 'cols-2' && 'md:grid-cols-2',
			grid() === 'cols-3' && 'md:grid-cols-3'
		)
	"
	data-test-id="selection-card"
>
	@for (option of options(); track option.inputId) {
		<vp-selection-card-input
			[controlType]="cardControlType"
			[hasCardsAsMarkdown]="hasCardsAsMarkdown()"
			[hasError]="hasError()"
			[hideNativeInput]="hideNativeInput()"
			[isDisabled]="isDisabled()"
			[isReadonly]="isReadonly()"
			[isSelected]="option.selected"
			[name]="name()"
			[option]="option"
			[stacked]="stacked()"
			(changed)="updateOptions($event)"
		/>
	}
</div>
